<!--
Copyright 2022 LINE Fukuoka Corporation

LINE Corporation licenses this file to you under the Apache License,
version 2.0 (the "License"); you may not use this file except in compliance
with the License. You may obtain a copy of the License at:

  https://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the
License for the specific language governing permissions and limitations
under the License.
-->
<template>
  <v-select
    class="languageSuggest"
    v-model="value"
    :rules="[validateRequired]"
    :items="languageSettingOptions"
    item-text="languageNativeName"
    item-value="languageCode"
    :label="title"
    clearable
    :required="required"
    :disabled="disabled"
    :no-data-text="noDataText"
  ></v-select>
</template>
<script>
import Vue from "vue";
import InputBase from "./InputBase.vue";

export default Vue.extend({
  name: "InputLanguageSuggest",
  mixins: [InputBase],
  props: {
    mlLibJson:Object,
    isLiffMode: Boolean,
    isAdminMode: Boolean,
  },
  computed: {},
  data() {
    return {
      value: null,
      noDataText: "",
    };
  },
  mounted(){
    if(this.mlLibJson){
      this.noDataText = "検索結果が見つかりません。";
    }
  },
  created() {
    let params = Object.assign(
      {
        languageSettingOptions: [],
        isRequired: { value: false },
        isRequiredForUser: { value: false },
        input: undefined,
      },
      this.params
    );

    this.itemKey = this.params.itemKey;
    this.languageSettingOptions = params.languageSettingOptions;
    this.required = params.isRequired.value;
    this.isRequiredForUser = params.isRequiredForUser.value;
    this.value = params.input;
  },
  methods: {
    getValue() {
      return this.value;
    },
    validateRequired() {
      const validateResult = (this.value !== undefined && this.value !== null && this.value !== "") || "必須項目";
      if (this.isAdminMode) {
        return !this.required || validateResult;
      } else if (this.isLiffMode) {
        return (!this.required && !this.isRequiredForUser) || validateResult;
      }
    },
  },
});
</script>

<style scoped>
.v-menu__content .v-list ::v-deep .v-list-item .v-list-item__content .v-list-item__title {
  min-height: 30px;
  display: flex;
  align-items: center;
}
</style>

<style>
.languageSuggest .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection {
  line-height: 1.7!important;
}
</style>